import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import usePortalModal from 'hooks/usePortalModal';
import React from 'react';
import { functionUtils } from 'utils';
import Popup from './popup';

const PaytoNoChangeModal = ({ isShow, action, actionOnClose, modalData }) => {
  const { closePortalModalName } = usePortalModal();

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(action)) {
      actionOnClose();
    }
    closePortalModalName();
  };

  return (
    <Popup
      isOpen={isShow}
      imageSrc={NoticeIcon}
      imagesStyles={{
        width: '75px',
        height: '60px',
        objectFit: 'contain',
      }}
      alignContent="center"
      onClick={handleOnClick}
      onClose={handleOnClose}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
      errorData={modalData}
    />
  );
};

export default PaytoNoChangeModal;
